module.exports = __webpack_public_path__ + "img/AGILITY.1b07eadb.png";